/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DriverRegistrationLogLastStep } from './DriverRegistrationLogLastStep';
import type { DriverRegistrationLogType } from './DriverRegistrationLogType';

export interface GetDriverRegistrationResponse {
    /** min length: 40, max length: 40 */
    hash: string;
    last_step: DriverRegistrationLogLastStep;
    /** min length: 0, max length: 40 */
    account_branch_code: string | null;
    /** min length: 0, max length: 255 */
    address: string | null;
    /** min length: 0, max length: 255 */
    beneficiary_name: string | null;
    birthday: string | null;
    /** min length: 1, max length: 50 */
    car_color: string | null;
    car_model_id: number | null;
    /** min length: 0, max length: 50 */
    car_transport_licence_number: string | null;
    /** min length: 0, max length: 255 */
    city: string | null;
    company_is_liable_to_vat: 0 | 1 | null;
    /** min length: 0, max length: 255 */
    company_name: string | null;
    /** 2 char country code, for example: \'us\', \'ee\', \'gb\' */
    country: string | null;
    /** min length: 0, max length: 30 */
    display_name: string | null;
    /** min length: 0, max length: 20 */
    driver_license: string | null;
    /** max length: 2147483647 */
    email: string | null;
    /** min length: 0, max length: 255 */
    first_name: string | null;
    flow_id: number | null;
    has_car: 0 | 1 | null;
    has_taxi_license: 0 | 1 | null;
    /** min length: 0, max length: 40 */
    iban: string | null;
    /** min length: 2, max length: 2 */
    language: string | null;
    /** min length: 0, max length: 255 */
    last_name: string | null;
    /** min length: 1, max length: 50 */
    license_plate: string | null;
    /** min length: 0, max length: 255 */
    model: string | null;
    /** min length: 0, max length: 50 */
    personal_code: string | null;
    /** min length: 1, max length: 20 */
    phone: string | null;
    /** min length: 0, max length: 255 */
    reg_code: string | null;
    seats: number | null;
    /** min length: 0, max length: 40 */
    swift: string | null;
    /** min length: 0, max length: 20 */
    taxi_license: string | null;
    type: DriverRegistrationLogType | null;
    /** min length: 0, max length: 255 */
    vat_code: string | null;
    /** min length: 0, max length: 18 */
    vin: string | null;
    year: string | null;
}
